import { tomsRiverConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function TomsRiverPage() {
  return <CityPageTemplate config={tomsRiverConfig} />;
}